import React, { useState } from 'react';
import { LocationCard } from '../../location/card/LocationCard';
import { UiGrid } from '@open-stack/ui';
import { useRouter } from '../../../hooks/router';
import { RootIdPage } from '../../../pages/id/RootIdPage';
import { useZoneHistory } from '../../../hooks/zone-history';
import { Outlet } from '../../../XV2';
import { XPageHeader } from '../../x/page/header/XPageHeader';
import { XButton, XFormInput, XSection, XSectionHeader } from '@orderx/lab/ui';
import { Zone } from '../../../XV2';
import { stringIncludes } from '../../../util/stringIncludes';

interface Props {
    tagId: string;
    title?: string;
    outlets: (Pick<Outlet, 'id' | 'name' | 'description' | 'isClosed' | 'image'> & {
        zones: Pick<Zone, 'id' | 'name'>[];
    })[];
}

export function TagOutletGroup({ title, outlets }: Props) {
    const {
        location: { pathname },
    } = useRouter();
    const [outlet, setOutlet] = useState<
        Pick<Outlet, 'id' | 'name'> & {
            zones: Pick<Zone, 'id' | 'name'>[];
        }
    >();
    const zoneHistory = useZoneHistory();
    const [keyword, setKeyword] = useState('');

    if (outlet) {
        return (
            <>
                <XPageHeader title={outlet.name} backButtonOnClick={() => setOutlet(undefined)} />

                <XSection>
                    {outlet.zones.length > 100 && (
                        <XFormInput value={keyword} onChangeValue={setKeyword} placeholder={'Type to search'} />
                    )}
                </XSection>

                <XSection>
                    <UiGrid minMax={100}>
                        {outlet.zones
                            .filter((zone) => stringIncludes(zone.name, keyword))
                            .map((zone) => (
                                <XButton
                                    to={[RootIdPage, { id: zone.id }]}
                                    onClick={() => zoneHistory.setPath(zone.id, pathname)}
                                    fullWidth>
                                    {zone.name}
                                </XButton>
                            ))}
                    </UiGrid>
                </XSection>
            </>
        );
    }

    return (
        <>
            <XSectionHeader title={title || 'Choose outlet'} />

            <XSection>
                <UiGrid minMax={320}>
                    {outlets.map((outlet) => (
                        <LocationCard
                            name={outlet.name}
                            description={outlet.description}
                            isClosed={outlet.isClosed}
                            image={outlet.image}
                            onClick={() => {
                                setOutlet(outlet);
                            }}
                            key={outlet.id}
                        />
                    ))}
                </UiGrid>
            </XSection>
        </>
    );
}
